import { render, staticRenderFns } from "./SummaryReporting.vue?vue&type=template&id=04e245e9"
import script from "./SummaryReporting.vue?vue&type=script&lang=js"
export * from "./SummaryReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports